export default __webpack_public_path__ + "static/media/icons.3aac0abe.svg";